import { get } from "@insite/client-framework/Services/ApiService";

const getWarehouseDataUrl = "/api/v1/ShopMyBranch";
const getDCLeftNavUrl = "/api/v1/ShopMyBranch/DCLeftNav";

export interface WarehouseInfoModal {
    name: string
    code: string
    attributeid: string,
    address1: string,
    address2: string,
    phone: string,
    city: string,
    state: string,
    zipCode: string,
    fax: string,
    manager: string,
    hours: string,
    email: string
}

export interface NavSubLevelModal {
    name: string,
    path: string,
    urlSegment: string
}

export interface DCLeftNavModal {
    attributeId?: string,
    dc?: any,
    brand?: NavSubLevelModal[],
    category?: NavSubLevelModal[],
    mwts?: NavSubLevelModal[]
}

export function getWarehouseData() {
    return get<WarehouseInfoModal>(`${getWarehouseDataUrl}`);
}

export function getDCLeftNavData() {
    return get<DCLeftNavModal>(`${getDCLeftNavUrl}`);
}